<template>
	<div class="wrap-footer">
		<div class="footer">
			<div class="inner">

				<!--艺人之家简介-->
				<div class="introduce">
					<h3 class="title">
						华誉传奇-艺人之家
						<p class="en">Asian Artists House</p>
					</h3>
					<p class="intro">
						亚洲艺人之家 是华誉传奇影业旗下全媒体娱乐营销平台与艺人经纪平台，拥有全媒体营销矩阵，线下杂志，幕后有着强大的内容策划团队、媒体营销团队、视觉制作团队。为娱乐圈艺人、机构、影视宣传提供专业的营销推广。同时打造属于自己的专业的艺人梯队， 亚洲艺人之家致力于打造互联网全方面的娱乐营销平台!
					</p>
				</div>

				<!--合作平台-->
				<div class="cooperate">
					<h3 class="title">
						合作平台
						<p class="en"></p>
					</h3>
					<ul class="list">
						<li>
							<a target="_blank" href="https://www.xinpianchang.com/yzyrzj  ">
								新片场主页
							</a>
						</li>
						<li>
							<a target="_blank" href="https://so.iqiyi.com/so/q_%E4%BA%9A%E6%B4%B2%E8%89%BA%E4%BA%BA%E4%B9%8B%E5%AE%B6?source=input&sr=1344008942490">
								爱奇艺主页
							</a>
						</li>
						<li>
							<a target="_blank" href="https://so.youku.com/search_video/q_%E4%BA%9A%E6%B4%B2%E8%89%BA%E4%BA%BA%E4%B9%8B%E5%AE%B6?f=1&kb=020200000000000__%E4%BA%9A%E6%B4%B2%E8%89%BA%E4%BA%BA%E4%B9%8B%E5%AE%B6">
								优酷主页
							</a>
						</li>
						<li>
							<a target="_blank" href="https://www.baidu.com/s?wd=%E4%BA%9A%E6%B4%B2%E8%89%BA%E4%BA%BA%E4%B9%8B%E5%AE%B6&rsv_spt=1&rsv_iqid=0xba2232400001b052&issp=1&f=8&rsv_bp=1&rsv_idx=2&ie=utf-8&rqlang=cn&tn=baiduhome_pg&rsv_enter=0&oq=%25E4%25BA%259A%25E6%25B4%25B2%25E8%2589%25BA%25E4%25BA%25BA%25E4%25B9%258B%25E5%25AE%25B6&rsv_t=8c23y%2BM%2BAaFNdgelIIcOfUBWOWhv5IcnD7HjhrjRBzFGr2vp4i5%2FDCdOuB%2B6%2FmvWDb%2B9&rsv_pq=adcf8eaa0000148d">
								百度百科
							</a>
						</li>
					</ul>
				</div>

				<!--网站导航-->
				<div class="navigator">
					<h3 class="title">
						网站导航
						<p class="en"></p>
					</h3>
					<ul class="list">
						<li>
							<router-link to="/baike">
								艺人百科
							</router-link>
						</li>
						<li>
							<router-link to="/juzu">
								剧组信息
							</router-link>
						</li>
						<li>
							<router-link to="/hot">
								娱情一线
							</router-link>
						</li>
						<li>
							<router-link to="/video">
								娱人工访
							</router-link>
						</li>
					</ul>
				</div>

				<!--官方平台-->
				<div class="code">
					<h3 class="title">
						官方平台
						<p class="en"></p>
					</h3>
					<ul class="code-list">
						<li>
							<div class="img">
								<img src="../assets/images/weibo_code.png">
							</div>
							<p class="name">新浪官方微博</p>
						</li>
						<li>
							<div class="img">
								<img src="../assets/images/yiren_code.jpg">
							</div>
							<p class="name">华誉传奇</p>
						</li>
						<li>
							<div class="img">
								<img src="../assets/images/gong_code.jpeg">
							</div>
							<p class="name">微信公众号</p>
						</li>

					</ul>
				</div>

			</div>
		</div>
		<p class="txt">京ICP备18003512号</p>
	</div>

</template>
<script>

	export default {

		data() {
			return {


			}
		},
		methods:{

		},
		created(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	.wrap-footer{
		.inner{
			width: 1200px;
			display: block;
			margin: 0 auto;
			overflow: hidden;
		}
		.txt{
			height: 34px;
			text-align: center;
			line-height: 34px;
			color: #fff;
			background: #000;
			font-size: 12px;
		}

		.footer{
			height: 394px;
			background: url("../assets/images/footer_bg.jpg") no-repeat center center;
			background-size:100% 100%;
			padding: 100px 0;
			box-sizing: border-box;
			.inner{
				display: flex;
				justify-content: flex-end;
				line-height: 0;
				font-size: 0;
				color: #333;
				font-weight: bold;
				.title{
					font-size: 24px;
					line-height: 30px;
					.en{
						font-size: 18px;
						padding: 9px 0 18px 0;
						line-height: 18px;
						height: 18px;
					}
				}
				.list{
					li{
						font-size: 14px;
						padding-bottom: 20px;
						height: 14px;
						line-height: 14px;
						&:hover{
							a{
								color: #7E0007;
							}
						}
						a{
							display: block;
							font-weight: 500;
							color: #666;
						}
					}
				}
				.introduce{
					width: 270px;
					margin-right: 160px;
					.title{
						font-size: 30px;
					}
					.intro{
						font-size: 12px;
						line-height: 18px;
					}
				}
				.cooperate{
					width: 100px;
					margin-right: 100px;
				}
				.navigator{
					width: 100px;
					margin-right: 160px;
				}
				.code{
					flex: 1;
					.code-list{
						li{
							display: inline-block;
							width: 88px;
							margin-right: 20px;
							&:last-child{
								margin-right: 0;
							}
							.img{
								width: 88px;
								height: 88px;
								img{
									width: 100%;
									height: 100%;
								}
							}
							.name{
								text-align: center;
								font-size: 14px;
								height: 40px;
								line-height: 40px;
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue